module.exports = __webpack_public_path__ + "img/symbol_2.e73dc081.png";